module.exports = __webpack_public_path__ + "img/rule_bg.92bf3afd.png";